
























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'

import UserInterface2FolderDataTable from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-2-folder-data-table.vue'
import UserInterface5AreYouSure from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-5-are-you-sure.vue'

import {
  MessageHtmlItem,
  HTML_ITEM_ID_CHIP,
  HTML_ITEM_ID_ICON_WITH_TEXT
} from '../../../../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-1-data-structures/data-structures-1-root-state'

import {
  getTransactionProcessingStatusAlgorithm,
  TRANSACTION_PROCESSING_COMPLETE,
  TRANSACTION_PROCESSING_PENDING,
  TRANSACTION_PROCESSING_FAILED,
  TRANSACTION_PROCESSING_FAILED_WITH_RECURRING_TRANSACTION,
  TRANSACTION_PROCESSING_STOPPED_WITH_RECURRING_TRANSACTION,
  TRANSACTION_PROCESSING_ACTIVE_WITH_RECURRING_TRANSACTION
} from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-1-algorithms/algorithms-type-9-initialize-digital-currency-transaction-list/service-for-helper-algorithms/helper-algorithms-2-get-transaction-processing-status'

import {
  DataTableFile,
  itemTypeFolder,
  GraphViewDataTableItem,
  // itemTypeFolder,
  itemTypeGraph,
  itemTypeDescriptionList,
  // itemTypeAccount
  itemTypeTransaction
} from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

import {
  // Values
  AMOUNT_OF_DIGITAL_CURRENCY_SENT_VALUE,
  AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_VALUE,
  TOTAL_DIGITAL_CURRENCY_BALANCE_VALUE,

  NUMBER_OF_TRANSACTIONS_CREATED_VALUE,
  NUMBER_OF_TRANSACTIONS_RECEIVED_VALUE,
  NUMBER_OF_TRANSACTIONS_DELETED_VALUE,
  TOTAL_ACTIVE_TRANSACTIONS_VALUE,

  NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_VALUE,
  NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_VALUE,
  NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_VALUE,
  TOTAL_ACTIVE_RECURRING_TRANSACTIONS_VALUE,

  TOTAL_RECURRING_TRANSACTION_INCOME_VALUE,
  TOTAL_RECURRING_TRANSACTION_EXPENDITURE_VALUE,

  NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_VALUE,
  NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_VALUE,

  // Data Tables

  CREATED_TRANSACTION_DATA_TABLE,
  RECEIVED_TRANSACTION_DATA_TABLE,

  // Bar Graphs

  AMOUNT_OF_DIGITAL_CURRENCY_SENT_GRAPH,
  AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_GRAPH,
  TOTAL_DIGITAL_CURRENCY_BALANCE_GRAPH,

  NUMBER_OF_TRANSACTIONS_CREATED_GRAPH,
  NUMBER_OF_TRANSACTIONS_RECEIVED_GRAPH,
  NUMBER_OF_TRANSACTIONS_DELETED_GRAPH,
  TOTAL_ACTIVE_TRANSACTIONS_GRAPH,

  NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_GRAPH,
  NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_GRAPH,
  NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_GRAPH,
  TOTAL_ACTIVE_RECURRING_TRANSACTIONS_GRAPH,

  TOTAL_RECURRING_TRANSACTION_INCOME_GRAPH,
  TOTAL_RECURRING_TRANSACTION_EXPENDITURE_GRAPH,

  NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_GRAPH,
  NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_GRAPH
} from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-3-constants/constants-3-transaction-account-statistics'

import {
  CREATED_TRANSACTIONS,
  RECEIVED_TRANSACTIONS
} from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-3-constants/constants-3-account-notifications'

import {
  DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE
} from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-3-constants/constants-5-service-type'

import { DigitalCurrencyTransaction } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-2-data-structures/data-structures-type-1-transaction/transaction-1'

import { projectVariables } from '../../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { getDigitalCurrencyAmountWithCommaSeparatedValue } from '../../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-2-get-digital-currency-amount-with-comma-separated-value'
// import { getTimeUntilMillisecondDurationReached } from '../../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-4-get-time-until-millisecond-duration-reached'

import {
  universalBasicIncomeTransaction,
  numberOfSpecialTransactions
} from '../../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-4-digital-currency'
import { addDatedElementToList } from '../../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-8-add-dated-element-to-list'

import { GetAccountTransactionStatisticsOptions } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-2-data-structures/data-structures-type-3-transaction-account-statistics/transaction-account-statistics-2'

import moment from 'moment'

const namespace = 'digitalCurrency'

@Component({
  components: {
    UserInterface2FolderDataTable,
    UserInterface5AreYouSure
  }
})
class AccountResourceItem3TransactionStatistics extends Vue {

  @Prop({ default: '' }) digitalCurrencyAccountId?: string

  @Action('getDigitalCurrencyAccountTransactionStatistics', { namespace }) getDigitalCurrencyAccountTransactionStatistics?: any
  @Action('addEventListenerToDigitalCurrencyAccountTransactionStatistics', { namespace }) addEventListenerToDigitalCurrencyAccountTransactionStatistics?: any
  @Action('removeEventListenerFromDigitalCurrencyAccountTransactionStatistics', { namespace }) removeEventListenerFromDigitalCurrencyAccountTransactionStatistics?: any
  @Action('getDigitalCurrencyTransactionById', { namespace }) getDigitalCurrencyTransactionById?: any
  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any
  @Action('deleteDigitalCurrencyTransaction', { namespace }) deleteDigitalCurrencyTransaction?: any

  @Action('updateDigitalCurrencyAccountNotifications', { namespace }) updateDigitalCurrencyAccountNotifications?: any

  initialFile: DataTableFile = new DataTableFile()

  currentSelectedItem: DataTableFile = new DataTableFile()

  selectedGroupItemList: GraphViewDataTableItem[] = []

  // Are You Sure Dialog
  showAreYouSureDialog: boolean = false
  areYouSureDialogIconId: string = ''
  areYouSureDialogTitle: string = ''
  areYouSureDialogMessage: string = ''
  areYouSureDialogHeaderCssClass: string = ''
  areYouSureDialogYesOptionEvaluationFunction: any = () => false

  // Statistics
  amountOfDigitalCurrencySentValue: number = 0
  amountOfDigitalCurrencyReceivedValue: number = 0
  totalDigitalCurrencyBalanceValue: number = 0
  numberOfTransactionsCreatedValue: number = 0
  numberOfTransactionsReceivedValue: number = 0
  numberOfTransactionsDeletedValue: number = 0
  totalActiveTransactionsValue: number = 0
  numberOfRecurringTransactionsCreatedValue: number = 0
  numberOfRecurringTransactionsReceivedValue: number = 0
  numberOfRecurringTransactionsDeletedValue: number = 0
  totalActiveRecurringTransactionsValue: number = 0
  totalRecurringTransactionIncomeValue: number = 0
  totalRecurringTransactionExpenditureValue: number = 0
  numberOfAccountsSentATransactionToValue: number = 0
  numberOfAccountsReceivedATransactionFromValue: number = 0

  createdTransactionDataList: Array<GraphViewDataTableItem> = []
  receivedTransactionDataList: Array<GraphViewDataTableItem> = []

  amountOfDigitalCurrencySentGraphDateList: number[] = []
  amountOfDigitalCurrencySentGraphDataList: number[] = []

  amountOfDigitalCurrencyReceivedGraphDateList: number[] = []
  amountOfDigitalCurrencyReceivedGraphDataList: number[] = []

  totalDigitalCurrencyBalanceGraphDateList: number[] = []
  totalDigitalCurrencyBalanceGraphDataList: number[] = []

  numberOfTransactionsCreatedGraphDateList: number[] = []
  numberOfTransactionsCreatedGraphDataList: number[] = []

  numberOfTransactionsReceivedGraphDateList: number[] = []
  numberOfTransactionsReceivedGraphDataList: number[] = []

  numberOfTransactionsDeletedGraphDateList: number[] = []
  numberOfTransactionsDeletedGraphDataList: number[] = []

  totalActiveTransactionsGraphDateList: number[] = []
  totalActiveTransactionsGraphDataList: number[] = []

  numberOfRecurringTransactionsCreatedGraphDateList: number[] = []
  numberOfRecurringTransactionsCreatedGraphDataList: number[] = []

  numberOfRecurringTransactionsReceivedGraphDateList: number[] = []
  numberOfRecurringTransactionsReceivedGraphDataList: number[] = []

  numberOfRecurringTransactionsDeletedGraphDateList: number[] = []
  numberOfRecurringTransactionsDeletedGraphDataList: number[] = []

  totalActiveRecurringTransactionsGraphDateList: number[] = []
  totalActiveRecurringTransactionsGraphDataList: number[] = []

  totalRecurringTransactionIncomeGraphDateList: number[] = []
  totalRecurringTransactionIncomeGraphDataList: number[] = []

  totalRecurringTransactionExpenditureGraphDateList: number[] = []
  totalRecurringTransactionExpenditureGraphDataList: number[] = []

  numberOfAccountsSentATransactionToGraphDateList: number[] = []
  numberOfAccountsSentATransactionToGraphDataList: number[] = []

  numberOfAccountsReceivedATransactionFromGraphDateList: number[] = []
  numberOfAccountsReceivedATransactionFromGraphDataList: number[] = []


  // Statistics Event Listener
  amountOfDigitalCurrencySentValueEventListenerId: string = ''
  amountOfDigitalCurrencyReceivedValueEventListenerId: string = ''
  totalDigitalCurrencyBalanceValueEventListenerId: string = ''
  numberOfTransactionsCreatedValueEventListenerId: string = ''
  numberOfTransactionsReceivedValueEventListenerId: string = ''
  numberOfTransactionsDeletedValueEventListenerId: string = ''
  totalActiveTransactionsValueEventListenerId: string = ''
  numberOfRecurringTransactionsCreatedValueEventListenerId: string = ''
  numberOfRecurringTransactionsReceivedValueEventListenerId: string = ''
  numberOfRecurringTransactionsDeletedValueEventListenerId: string = ''
  totalActiveRecurringTransactionsValueEventListenerId: string = ''
  totalRecurringTransactionIncomeValueEventListenerId: string = ''
  totalRecurringTransactionExpenditureValueEventListenerId: string = ''
  numberOfAccountsSentATransactionToValueEventListenerId: string = ''
  numberOfAccountsReceivedATransactionFromValueEventListenerId: string = ''

  createdTransactionDataTableEventListenerId: string = ''
  receivedTransactionDataTableEventListenerId: string = ''

  amountOfDigitalCurrencySentGraphEventListenerId: string = ''
  amountOfDigitalCurrencyReceivedGraphEventListenerId: string = ''
  totalDigitalCurrencyBalanceGraphEventListenerId: string = ''
  numberOfTransactionsCreatedGraphEventListenerId: string = ''
  numberOfTransactionsReceivedGraphEventListenerId: string = ''
  numberOfTransactionsDeletedGraphEventListenerId: string = ''
  totalActiveTransactionsGraphEventListenerId: string = ''
  numberOfRecurringTransactionsCreatedGraphEventListenerId: string = ''
  numberOfRecurringTransactionsReceivedGraphEventListenerId: string = ''
  numberOfRecurringTransactionsDeletedGraphEventListenerId: string = ''
  totalActiveRecurringTransactionsGraphEventListenerId: string = ''
  totalRecurringTransactionIncomeGraphEventListenerId: string = ''
  totalRecurringTransactionExpenditureGraphEventListenerId: string = ''
  numberOfAccountsSentATransactionToGraphEventListenerId: string = ''
  numberOfAccountsReceivedATransactionFromGraphEventListenerId: string = ''

  // Data Queues
  createdTransactionIdDataQueue: string[] = []
  receivedTransactionIdDataQueue: string[] = []

  // Loading Next Page Transactions
  initialNumberOfCreatedTransactionsLoaded: number = 100
  dateOfLatestCreatedTransactionLoaded: number = 0
  isCompletedLoadingAllCreatedTransactions: boolean = false
  promiseToLoadNextCreatedTransactions: Promise<any> | null = null

  initialNumberOfReceivedTransactionsLoaded: number = 100
  dateOfLatestReceivedTransactionLoaded: number = 0
  isCompletedLoadingAllReceivedTransactions: boolean = false
  promiseToLoadNextReceivedTransactions: Promise<any> | null = null
  numberOfSpecialReceivedTransactions: number = numberOfSpecialTransactions // ['universal-basic-income']

  async mounted () {
    // Values
    this.initializeAmountOfDigitalCurrencySentValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeAmountOfDigitalCurrencyReceivedValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalDigitalCurrencyBalanceValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfTransactionsCreatedValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfTransactionsReceivedValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfTransactionsDeletedValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalActiveTransactionsValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfRecurringTransactionsCreatedValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfRecurringTransactionsReceivedValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfRecurringTransactionsDeletedValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalActiveRecurringTransactionsValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalRecurringTransactionIncomeValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalRecurringTransactionExpenditureValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfAccountsSentATransactionToValue().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfAccountsReceivedATransactionFromValue().catch((errorMessage: any) => console.error(errorMessage))

    // Data Tables
    this.initializeCreatedTransactionDataTable().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeReceivedTransactionDataTable().catch((errorMessage: any) => console.error(errorMessage))

    // Bar Graphs
    this.initializeAmountOfDigitalCurrencySentGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeAmountOfDigitalCurrencyReceivedGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalDigitalCurrencyBalanceGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfTransactionsCreatedGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfTransactionsReceivedGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfTransactionsDeletedGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalActiveTransactionsGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfRecurringTransactionsCreatedGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfRecurringTransactionsReceivedGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfRecurringTransactionsDeletedGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalActiveRecurringTransactionsGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalRecurringTransactionIncomeGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeTotalRecurringTransactionExpenditureGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfAccountsSentATransactionToGraph().catch((errorMessage: any) => console.error(errorMessage))
    this.initializeNumberOfAccountsReceivedATransactionFromGraph().catch((errorMessage: any) => console.error(errorMessage))

  }

  destroyed () {
    this.removeEventListenerFromDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_SENT_VALUE,
      eventListenerId: this.amountOfDigitalCurrencySentValueEventListenerId,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Amount of Digital Currency Sent Value
  async initializeAmountOfDigitalCurrencySentValue () {
    const amountOfDigitalCurrencySent = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_SENT_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.amountOfDigitalCurrencySentValue = amountOfDigitalCurrencySent

    this.amountOfDigitalCurrencySentValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_SENT_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.amountOfDigitalCurrencySentValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Amount of Digital Currency Received Value
  async initializeAmountOfDigitalCurrencyReceivedValue () {
    const amountOfDigitalCurrencyReceived = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.amountOfDigitalCurrencyReceivedValue = amountOfDigitalCurrencyReceived

    this.amountOfDigitalCurrencyReceivedValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.amountOfDigitalCurrencyReceivedValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Digital Currency Balance Value
  async initializeTotalDigitalCurrencyBalanceValue () {
    const totalDigitalCurrencyBalance = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_DIGITAL_CURRENCY_BALANCE_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalDigitalCurrencyBalanceValue = totalDigitalCurrencyBalance

    this.totalDigitalCurrencyBalanceValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_DIGITAL_CURRENCY_BALANCE_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.totalDigitalCurrencyBalanceValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Transactions Created Value
  async initializeNumberOfTransactionsCreatedValue () {
    const numberOfTransactionsCreated = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_CREATED_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfTransactionsCreatedValue = numberOfTransactionsCreated

    this.numberOfTransactionsCreatedValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_CREATED_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfTransactionsCreatedValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Transactions Received Value
  async initializeNumberOfTransactionsReceivedValue () {
    const numberOfTransactionsReceived = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_RECEIVED_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfTransactionsReceivedValue = numberOfTransactionsReceived

    this.numberOfTransactionsReceivedValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_RECEIVED_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfTransactionsReceivedValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Transactions Deleted Value
  async initializeNumberOfTransactionsDeletedValue () {
    const numberOfTransactionsDeleted = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_DELETED_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfTransactionsDeletedValue = numberOfTransactionsDeleted

    this.numberOfTransactionsDeletedValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_DELETED_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfTransactionsDeletedValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Active Transactions Value
  async initializeTotalActiveTransactionsValue () {
    const totalActiveTransactions = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_TRANSACTIONS_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalActiveTransactionsValue = totalActiveTransactions

    this.totalActiveTransactionsValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_TRANSACTIONS_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.totalActiveTransactionsValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number Of Recurring Transactions Created Value
  async initializeNumberOfRecurringTransactionsCreatedValue () {
    const numberOfRecurringTransactionsCreated = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfRecurringTransactionsCreatedValue = numberOfRecurringTransactionsCreated

    this.numberOfRecurringTransactionsCreatedValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfRecurringTransactionsCreatedValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number Of Recurring Transactions Received Value
  async initializeNumberOfRecurringTransactionsReceivedValue () {
    const numberOfRecurringTransactionsCreated = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfRecurringTransactionsReceivedValue = numberOfRecurringTransactionsCreated

    this.numberOfRecurringTransactionsReceivedValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfRecurringTransactionsReceivedValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number Of Recurring Transactions Deleted Value
  async initializeNumberOfRecurringTransactionsDeletedValue () {
    const numberOfRecurringTransactionsDeleted = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfRecurringTransactionsDeletedValue = numberOfRecurringTransactionsDeleted

    this.numberOfRecurringTransactionsDeletedValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfRecurringTransactionsDeletedValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Active Recurring Transactions Value
  async initializeTotalActiveRecurringTransactionsValue () {
    const totalActiveRecurringTransactions = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_RECURRING_TRANSACTIONS_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalActiveRecurringTransactionsValue = totalActiveRecurringTransactions

    this.totalActiveRecurringTransactionsValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_RECURRING_TRANSACTIONS_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.totalActiveRecurringTransactionsValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Recurring Transaction Income Value
  async initializeTotalRecurringTransactionIncomeValue () {
    const totalRecurringTransactionIncome = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_INCOME_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalRecurringTransactionIncomeValue = totalRecurringTransactionIncome

    this.totalRecurringTransactionIncomeValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_INCOME_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.totalRecurringTransactionIncomeValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Recurring Transaction Expenditure Value
  async initializeTotalRecurringTransactionExpenditureValue () {
    const totalRecurringTransactionExpenditure = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_EXPENDITURE_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalRecurringTransactionExpenditureValue = totalRecurringTransactionExpenditure

    this.totalRecurringTransactionExpenditureValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_EXPENDITURE_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.totalRecurringTransactionExpenditureValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Accounts Sent A Transaction To Value
  async initializeNumberOfAccountsSentATransactionToValue () {
    const numberOfAccountsSentATransactionTo = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfAccountsSentATransactionToValue = numberOfAccountsSentATransactionTo

    this.numberOfAccountsSentATransactionToValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfAccountsSentATransactionToValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Accounts Received A Transaction From Value
  async initializeNumberOfAccountsReceivedATransactionFromValue () {
    const numberOfAccountsReceivedATransactionFrom = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_VALUE,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfAccountsReceivedATransactionFromValue = numberOfAccountsReceivedATransactionFrom

    this.numberOfAccountsReceivedATransactionFromValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfAccountsReceivedATransactionFromValue = data
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Created Transaction Data Table
  async initializeCreatedTransactionDataTable () {
    const networkStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: CREATED_TRANSACTION_DATA_TABLE,
      statisticsOptions: {
        digitalCurrencyAccountId: this.digitalCurrencyAccountId,
        getItem1Options: {
          orderByValue: true,
          limitToLast: this.initialNumberOfCreatedTransactionsLoaded
        }
      } as GetAccountTransactionStatisticsOptions
    })

    if (!networkStatistics.dataList || networkStatistics.dataList.length === 0) {
      return
    }

    if (networkStatistics.dataList.length < this.initialNumberOfCreatedTransactionsLoaded) {
      this.isCompletedLoadingAllCreatedTransactions = true
    }

    const createdTransactionDataList = await this.getDigitalCurrencyCreatedTransactionDataTableList(networkStatistics.dataList)
    this.dateOfLatestCreatedTransactionLoaded = createdTransactionDataList[createdTransactionDataList.length - 1].itemData.dateTransactionCreated

    Vue.set(this, 'createdTransactionDataList', createdTransactionDataList)

    this.createdTransactionDataTableEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: CREATED_TRANSACTION_DATA_TABLE,
      eventListenerCallbackFunction: this.eventListenerForCreatedTransactionDataTable,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Received Transaction Data Table
  async initializeReceivedTransactionDataTable () {
    const networkStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: RECEIVED_TRANSACTION_DATA_TABLE,
      statisticsOptions: {
        digitalCurrencyAccountId: this.digitalCurrencyAccountId,
        getItem1Options: {
          orderByValue: true,
          limitToLast: this.initialNumberOfReceivedTransactionsLoaded
        }
      }
    })

    // Add Universal Basic Income Transaction
    if (!networkStatistics.dataList) {
      networkStatistics.dataList = []
    }

    if (networkStatistics.dataList.length < this.initialNumberOfReceivedTransactionsLoaded) {
      this.isCompletedLoadingAllReceivedTransactions = true
    }

    networkStatistics.dataList.push(universalBasicIncomeTransaction.transactionId)

    let receivedTransactionDataList = await this.getDigitalCurrencyReceivedTransactionDataTableList(networkStatistics.dataList)
    if (networkStatistics.dataList.length > this.numberOfSpecialReceivedTransactions) {
      this.dateOfLatestReceivedTransactionLoaded = receivedTransactionDataList[receivedTransactionDataList.length - 1 - this.numberOfSpecialReceivedTransactions].itemData.dateTransactionCreated
    }

    Vue.set(this, 'receivedTransactionDataList', receivedTransactionDataList)

    this.receivedTransactionDataTableEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: RECEIVED_TRANSACTION_DATA_TABLE,
      eventListenerCallbackFunction: this.eventListenerForReceivedTransactionDataTable,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }


  async eventListenerForCreatedTransactionDataTable (data: any) {
    let { dataList } = data

    if (!dataList) {
      return
    }

    let digitalCurrencyTransactionIdList = []

    // Check if it's already in the queue
    // or already in the data list
    for (let i = 0; i < dataList.length; i++) {
      const digitalCurrencyTransactionId = dataList[i]
      const isAlreadyInQueue = this.createdTransactionIdDataQueue.indexOf(digitalCurrencyTransactionId) >= 0
      const isAlreadyInList = this.createdTransactionDataList.filter(item => {
        return item.itemId === digitalCurrencyTransactionId
      })[0] ? true : false

      if (isAlreadyInQueue || isAlreadyInList) {
        continue
      }
      digitalCurrencyTransactionIdList.push(digitalCurrencyTransactionId)
    }

    // Add data item to the queue
    this.createdTransactionIdDataQueue = [...digitalCurrencyTransactionIdList, ...this.createdTransactionIdDataQueue]

    if (digitalCurrencyTransactionIdList.length === 0) {
      return
    }

    dataList = [...this.createdTransactionIdDataQueue]

    let newDataList = await this.getDigitalCurrencyCreatedTransactionDataTableList(dataList)
    newDataList = [...newDataList, ...this.createdTransactionDataList]

    Vue.set(this, 'createdTransactionDataList', newDataList)

    // Remove items from the queue
    for (let i = 0; i < digitalCurrencyTransactionIdList.length; i++) {
      const dataItemIndex = this.createdTransactionIdDataQueue.indexOf(digitalCurrencyTransactionIdList[i])
      this.createdTransactionIdDataQueue.splice(dataItemIndex, 1)
    }
  }

  async eventListenerForReceivedTransactionDataTable (data: any) {
    let { dataList } = data

    if (!dataList) {
      return
    }

    let digitalCurrencyTransactionIdList = []

    // Check if it's already in the queue
    // or already in the data list
    for (let i = 0; i < dataList.length; i++) {
      const digitalCurrencyTransactionId = dataList[i]
      const isAlreadyInQueue = this.receivedTransactionIdDataQueue.indexOf(digitalCurrencyTransactionId) >= 0
      const isAlreadyInList = this.receivedTransactionDataList.filter(item => {
        return item.itemId === digitalCurrencyTransactionId
      })[0] ? true : false

      if (isAlreadyInQueue || isAlreadyInList) {
        continue
      }
      digitalCurrencyTransactionIdList.push(digitalCurrencyTransactionId)
    }

    // Add data item to the queue
    this.receivedTransactionIdDataQueue = [...digitalCurrencyTransactionIdList, ...this.receivedTransactionIdDataQueue]

    if (digitalCurrencyTransactionIdList.length === 0) {
      return
    }

    dataList = [...this.receivedTransactionIdDataQueue]

    let newDataList = await this.getDigitalCurrencyReceivedTransactionDataTableList(dataList)
    newDataList = [...newDataList, ...this.receivedTransactionDataList]

    Vue.set(this, 'receivedTransactionDataList', newDataList)

    // Remove items from the queue
    for (let i = 0; i < digitalCurrencyTransactionIdList.length; i++) {
      const dataItemIndex = this.receivedTransactionIdDataQueue.indexOf(digitalCurrencyTransactionIdList[i])
      this.receivedTransactionIdDataQueue.splice(dataItemIndex, 1)
    }
  }

  async getDigitalCurrencyCreatedTransactionDataTableList (transactionIdList: string[]) {
    let createdTransactionDataList: Array<GraphViewDataTableItem> = []

    for (let i = 0; i < transactionIdList.length; i++) {
      const digitalCurrencyTransactionId = transactionIdList[i]
      const digitalCurrencyTransaction: DigitalCurrencyTransaction = await this.getDigitalCurrencyTransactionById(digitalCurrencyTransactionId)
      if (!digitalCurrencyTransaction) {
        continue
      }
      const numberOfTransactionRecipients = digitalCurrencyTransaction ? Object.keys(digitalCurrencyTransaction.accountRecipientIdVariableTable || {}).length : 0
      const transactionRecipientAccount = digitalCurrencyTransaction ? await this.getDigitalCurrencyAccountById(Object.keys(digitalCurrencyTransaction.accountRecipientIdVariableTable || {})[0]) : null
      const transactionIconImageUrl: string = (numberOfTransactionRecipients === 1 && transactionRecipientAccount) ? transactionRecipientAccount.accountProfilePictureUrl : (numberOfTransactionRecipients === 2 ? 'group' : numberOfTransactionRecipients >= 3 ? 'groups' : 'person')
      const transactionStatusInformation = this.getDigitalCurrencyTransactionStatusInformation(digitalCurrencyTransaction)

      const itemIndex = createdTransactionDataList.push({
        itemType: itemTypeTransaction,
        itemId: digitalCurrencyTransaction ? digitalCurrencyTransaction.transactionId : digitalCurrencyTransactionId,
        itemName: digitalCurrencyTransaction ? `Transaction #${digitalCurrencyTransaction.transactionOrderIndex} (@${digitalCurrencyTransaction.transactionId})` : '(Deleted)',
        dateCreated: digitalCurrencyTransaction ? moment(digitalCurrencyTransaction.dateTransactionCreated).fromNow() : '',
        itemIconImageUrl: transactionIconImageUrl,
        itemData: {
          transactionPaymentAmount: digitalCurrencyTransaction ? `{{html1}}` : '',
          recurrencePeriod: digitalCurrencyTransaction ? (digitalCurrencyTransaction.isRecurringTransaction ? `{{html2}} ${digitalCurrencyTransaction.dateTransactionScheduledForCancellingRecurrence ? `Until ${moment(digitalCurrencyTransaction.dateTransactionScheduledForCancellingRecurrence).format('MMM DD, YYYY @ hh:mm')}` : ''}` : '{{html4}}') : '',
          transactionStatus: '{{html3}}',
          dateTransactionCreated: digitalCurrencyTransaction ? digitalCurrencyTransaction.dateTransactionCreated! : '',
          dateTransactionCreated2: digitalCurrencyTransaction ? moment(new Date(digitalCurrencyTransaction.dateTransactionCreated!)).format('MMMM DD YYYY') : '',
          textMemorandum: digitalCurrencyTransaction ? digitalCurrencyTransaction.textMemorandum : '',
          digitalCurrencyAccountSender: digitalCurrencyTransaction ? await this.getDigitalCurrencyAccountById(digitalCurrencyTransaction.accountSenderId) : null,
          digitalCurrencyAccountRecipientList: digitalCurrencyTransaction ? await Promise.all(Object.keys(digitalCurrencyTransaction.accountRecipientIdVariableTable || {}).map((digitalCurrencyAccountId: string) => this.getDigitalCurrencyAccountById(digitalCurrencyAccountId))) : [],
          messageHtmlItemList: [{
            htmlItemId: HTML_ITEM_ID_CHIP,
            iconImageUrl: projectVariables.digitalCurrencySymbolImageIconUrl,
            text: `${getDigitalCurrencyAmountWithCommaSeparatedValue(digitalCurrencyTransaction.transactionCurrencyAmount)} ${projectVariables.digitalCurrencyName}`
          }, {
            htmlItemId: HTML_ITEM_ID_CHIP,
            iconImageUrl: 'loop',
            text: `Every ${getDigitalCurrencyAmountWithCommaSeparatedValue(digitalCurrencyTransaction.originalTimeNumberUntilNextRecurrence || 0)} ${digitalCurrencyTransaction.originalTimeScaleUntilNextRecurrence}`
          }, {
            htmlItemId: HTML_ITEM_ID_ICON_WITH_TEXT,
            iconImageUrl: transactionStatusInformation.transactionStatusIconId,
            text: transactionStatusInformation.transactionStatusText,
            iconImageColor: transactionStatusInformation.transactionStatusIconColor
          }, {
            htmlItemId: HTML_ITEM_ID_CHIP,
            text: 'One Time Payment'
          }] as MessageHtmlItem[]
        },
        openFolderOrFileItem: digitalCurrencyTransaction ? true : false,
        closingActionButtonIconId: 'visibility',
        closingActionButtonText: digitalCurrencyTransaction ? 'View Transaction' : ''
      }) - 1
      ;(createdTransactionDataList[itemIndex] as any).itemDataAsString = JSON.stringify(createdTransactionDataList[itemIndex])
    }

    createdTransactionDataList = createdTransactionDataList.sort((transactionA, transactionB) => {
      return transactionB.itemData.dateTransactionCreated - transactionA.itemData.dateTransactionCreated
    })

    return createdTransactionDataList
  }

  async getDigitalCurrencyReceivedTransactionDataTableList (transactionIdList: string[]) {
    let receivedTransactionDataList: Array<GraphViewDataTableItem> = []

    for (let i = 0; i < transactionIdList.length; i++) {
      const digitalCurrencyTransactionId = transactionIdList[i]
      const digitalCurrencyTransaction: DigitalCurrencyTransaction = await this.getDigitalCurrencyTransactionById(digitalCurrencyTransactionId)
      if (!digitalCurrencyTransaction) {
        continue
      }
      const transactionSenderAccount = await this.getDigitalCurrencyAccountById(digitalCurrencyTransaction.accountSenderId)
      const transactionIconImageUrl: string = transactionSenderAccount ? transactionSenderAccount.accountProfilePictureUrl : (digitalCurrencyTransaction.specialTransactionType ? projectVariables.projectImageIconUrl2 : 'person')
      const transactionStatusInformation = this.getDigitalCurrencyTransactionStatusInformation(digitalCurrencyTransaction)

      const itemIndex = receivedTransactionDataList.push({
        itemType: itemTypeTransaction,
        itemId: digitalCurrencyTransaction ? digitalCurrencyTransaction.transactionId : digitalCurrencyTransactionId,
        itemName: digitalCurrencyTransaction ? (digitalCurrencyTransaction.specialTransactionType ? digitalCurrencyTransaction.transactionName! : `Transaction #${digitalCurrencyTransaction.transactionOrderIndex} (@${digitalCurrencyTransaction.transactionId})`) : '(Deleted)',
        dateCreated: digitalCurrencyTransaction ? moment(digitalCurrencyTransaction.dateTransactionCreated).fromNow() : '',
        itemIconImageUrl: transactionIconImageUrl,
        itemData: {
          transactionPaymentAmount: digitalCurrencyTransaction ? `{{html1}}` : '',
          recurrencePeriod: digitalCurrencyTransaction ? (digitalCurrencyTransaction.isRecurringTransaction ? `{{html2}} ${digitalCurrencyTransaction.dateTransactionScheduledForCancellingRecurrence ? `Until ${moment(digitalCurrencyTransaction.dateTransactionScheduledForCancellingRecurrence).format('MMM DD, YYYY @ hh:mm')}` : ''}` : '{{html4}}') : '',
          transactionStatus: '{{html3}}',
          dateTransactionCreated: digitalCurrencyTransaction ? digitalCurrencyTransaction.dateTransactionCreated! : '',
          dateTransactionCreated2: digitalCurrencyTransaction ? moment(new Date(digitalCurrencyTransaction.dateTransactionCreated!)).format('MMMM DD YYYY') : '',
          textMemorandum: digitalCurrencyTransaction ? digitalCurrencyTransaction.textMemorandum : '',
          digitalCurrencyAccountSender: digitalCurrencyTransaction ? await this.getDigitalCurrencyAccountById(digitalCurrencyTransaction.accountSenderId) : null,
          digitalCurrencyAccountRecipientList: digitalCurrencyTransaction ? await Promise.all(Object.keys(digitalCurrencyTransaction.accountRecipientIdVariableTable || {}).map((digitalCurrencyAccountId: string) => this.getDigitalCurrencyAccountById(digitalCurrencyAccountId))) : [],
          messageHtmlItemList: [{
            htmlItemId: HTML_ITEM_ID_CHIP,
            iconImageUrl: projectVariables.digitalCurrencySymbolImageIconUrl,
            text: `${getDigitalCurrencyAmountWithCommaSeparatedValue(digitalCurrencyTransaction.transactionCurrencyAmount)} ${projectVariables.digitalCurrencyName}`
          }, {
            htmlItemId: HTML_ITEM_ID_CHIP,
            iconImageUrl: 'loop',
            text: `Every ${getDigitalCurrencyAmountWithCommaSeparatedValue(digitalCurrencyTransaction.originalTimeNumberUntilNextRecurrence || 0)} ${digitalCurrencyTransaction.originalTimeScaleUntilNextRecurrence}`
          }, {
            htmlItemId: HTML_ITEM_ID_ICON_WITH_TEXT,
            iconImageUrl: transactionStatusInformation.transactionStatusIconId,
            text: transactionStatusInformation.transactionStatusText,
            iconImageColor: transactionStatusInformation.transactionStatusIconColor
          }, {
            htmlItemId: HTML_ITEM_ID_CHIP,
            text: 'One Time Payment'
          }] as MessageHtmlItem[]
        },
        openFolderOrFileItem: digitalCurrencyTransaction ? true : false,
        closingActionButtonIconId: 'visibility',
        closingActionButtonText: digitalCurrencyTransaction ? 'View Transaction' : ''
      }) - 1
      ;(receivedTransactionDataList[itemIndex] as any).itemDataAsString = JSON.stringify(receivedTransactionDataList[itemIndex])
    }

    receivedTransactionDataList = receivedTransactionDataList.sort((transactionA, transactionB) => {
      return transactionB.itemData.dateTransactionCreated - transactionA.itemData.dateTransactionCreated
    })

    return receivedTransactionDataList
  }

  // Initialize Amount of Digital Currency Sent Graph
  async initializeAmountOfDigitalCurrencySentGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_SENT_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.amountOfDigitalCurrencySentGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.amountOfDigitalCurrencySentGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.amountOfDigitalCurrencySentGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_SENT_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.amountOfDigitalCurrencySentGraphDateList, this.amountOfDigitalCurrencySentGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'amountOfDigitalCurrencySentGraphDateList', mergedData.dateList)
        Vue.set(this, 'amountOfDigitalCurrencySentGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Amount of Digital Currency Received Graph
  async initializeAmountOfDigitalCurrencyReceivedGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.amountOfDigitalCurrencyReceivedGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.amountOfDigitalCurrencyReceivedGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.amountOfDigitalCurrencyReceivedGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.amountOfDigitalCurrencyReceivedGraphDateList, this.amountOfDigitalCurrencyReceivedGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'amountOfDigitalCurrencyReceivedGraphDateList', mergedData.dateList)
        Vue.set(this, 'amountOfDigitalCurrencyReceivedGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Digital Currency Balance Graph
  async initializeTotalDigitalCurrencyBalanceGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_DIGITAL_CURRENCY_BALANCE_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalDigitalCurrencyBalanceGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.totalDigitalCurrencyBalanceGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.totalDigitalCurrencyBalanceGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_DIGITAL_CURRENCY_BALANCE_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.totalDigitalCurrencyBalanceGraphDateList, this.totalDigitalCurrencyBalanceGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'totalDigitalCurrencyBalanceGraphDateList', mergedData.dateList)
        Vue.set(this, 'totalDigitalCurrencyBalanceGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Transactions Created Graph
  async initializeNumberOfTransactionsCreatedGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_CREATED_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfTransactionsCreatedGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfTransactionsCreatedGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfTransactionsCreatedGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_CREATED_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfTransactionsCreatedGraphDateList, this.numberOfTransactionsCreatedGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfTransactionsCreatedGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfTransactionsCreatedGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Transactions Received Graph
  async initializeNumberOfTransactionsReceivedGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_RECEIVED_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfTransactionsReceivedGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfTransactionsReceivedGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfTransactionsReceivedGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_RECEIVED_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfTransactionsReceivedGraphDateList, this.numberOfTransactionsReceivedGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfTransactionsReceivedGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfTransactionsReceivedGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Transactions Deleted Graph
  async initializeNumberOfTransactionsDeletedGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_DELETED_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfTransactionsDeletedGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfTransactionsDeletedGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfTransactionsDeletedGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_TRANSACTIONS_DELETED_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfTransactionsDeletedGraphDateList, this.numberOfTransactionsDeletedGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfTransactionsDeletedGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfTransactionsDeletedGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Active Transactions Graph
  async initializeTotalActiveTransactionsGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_TRANSACTIONS_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalActiveTransactionsGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.totalActiveTransactionsGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.totalActiveTransactionsGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_TRANSACTIONS_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.totalActiveTransactionsGraphDateList, this.totalActiveTransactionsGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'totalActiveTransactionsGraphDateList', mergedData.dateList)
        Vue.set(this, 'totalActiveTransactionsGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number Of Recurring Transactions Created Graph
  async initializeNumberOfRecurringTransactionsCreatedGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfRecurringTransactionsCreatedGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfRecurringTransactionsCreatedGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfRecurringTransactionsCreatedGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfRecurringTransactionsCreatedGraphDateList, this.numberOfRecurringTransactionsCreatedGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfRecurringTransactionsCreatedGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfRecurringTransactionsCreatedGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number Of Recurring Transactions Received Graph
  async initializeNumberOfRecurringTransactionsReceivedGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfRecurringTransactionsReceivedGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfRecurringTransactionsReceivedGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfRecurringTransactionsReceivedGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfRecurringTransactionsReceivedGraphDateList, this.numberOfRecurringTransactionsReceivedGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfRecurringTransactionsReceivedGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfRecurringTransactionsReceivedGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number Of Recurring Transactions Deleted Graph
  async initializeNumberOfRecurringTransactionsDeletedGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfRecurringTransactionsDeletedGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfRecurringTransactionsDeletedGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfRecurringTransactionsDeletedGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfRecurringTransactionsDeletedGraphDateList, this.numberOfRecurringTransactionsDeletedGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfRecurringTransactionsDeletedGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfRecurringTransactionsDeletedGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Active Recurring Transactions Graph
  async initializeTotalActiveRecurringTransactionsGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_RECURRING_TRANSACTIONS_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalActiveRecurringTransactionsGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.totalActiveRecurringTransactionsGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.totalActiveRecurringTransactionsGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_ACTIVE_RECURRING_TRANSACTIONS_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.totalActiveRecurringTransactionsGraphDateList, this.totalActiveRecurringTransactionsGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'totalActiveRecurringTransactionsGraphDateList', mergedData.dateList)
        Vue.set(this, 'totalActiveRecurringTransactionsGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Recurring Transaction Income Graph
  async initializeTotalRecurringTransactionIncomeGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_INCOME_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalRecurringTransactionIncomeGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.totalRecurringTransactionIncomeGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.totalRecurringTransactionIncomeGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_INCOME_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.totalRecurringTransactionIncomeGraphDateList, this.totalRecurringTransactionIncomeGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'totalRecurringTransactionIncomeGraphDateList', mergedData.dateList)
        Vue.set(this, 'totalRecurringTransactionIncomeGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Total Recurring Transaction Expenditure Graph
  async initializeTotalRecurringTransactionExpenditureGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_EXPENDITURE_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.totalRecurringTransactionExpenditureGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.totalRecurringTransactionExpenditureGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.totalRecurringTransactionExpenditureGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: TOTAL_RECURRING_TRANSACTION_EXPENDITURE_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.totalRecurringTransactionExpenditureGraphDateList, this.totalRecurringTransactionExpenditureGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'totalRecurringTransactionExpenditureGraphDateList', mergedData.dateList)
        Vue.set(this, 'totalRecurringTransactionExpenditureGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Accounts Sent A Transaction To Graph
  async initializeNumberOfAccountsSentATransactionToGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfAccountsSentATransactionToGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfAccountsSentATransactionToGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfAccountsSentATransactionToGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfAccountsSentATransactionToGraphDateList, this.numberOfAccountsSentATransactionToGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfAccountsSentATransactionToGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfAccountsSentATransactionToGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  // Initialize Number of Accounts Received A Transaction From Graph
  async initializeNumberOfAccountsReceivedATransactionFromGraph () {
    const accountTransactionStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_GRAPH,
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
    this.numberOfAccountsReceivedATransactionFromGraphDateList = accountTransactionStatistics.dateList.reverse()
    this.numberOfAccountsReceivedATransactionFromGraphDataList = accountTransactionStatistics.dataList.reverse()

    this.numberOfAccountsReceivedATransactionFromGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountTransactionStatistics({
      statisticsType: NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_GRAPH,
      eventListenerCallbackFunction: (data: any) => {
        const mergedData = addDatedElementToList(this.numberOfAccountsReceivedATransactionFromGraphDateList, this.numberOfAccountsReceivedATransactionFromGraphDataList, data.dateList || [], data.dataList || [])
        Vue.set(this, 'numberOfAccountsReceivedATransactionFromGraphDateList', mergedData.dateList)
        Vue.set(this, 'numberOfAccountsReceivedATransactionFromGraphDataList', mergedData.dataList)
      },
      statisticsOptions: { digitalCurrencyAccountId: this.digitalCurrencyAccountId }
    })
  }

  async initializeInitialFile () {

    // Values
    const valuesDataTableFile = new DataTableFile()
    valuesDataTableFile.itemType = itemTypeDescriptionList
    valuesDataTableFile.itemId = 'values'
    valuesDataTableFile.itemName = 'Values'
    valuesDataTableFile.itemIconImageUrl = 'plus_one'
    valuesDataTableFile.itemData = {
      descriptionListItemList: [{
        propertyName: 'Amount of Digital Currency Sent',
        propertyIconId: 'send',
        propertyValue: this.amountOfDigitalCurrencySentValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyShowNumberOfTransactions: true,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Amount of Digital Currency Received',
        propertyIconId: 'vertical_align_bottom',
        propertyValue: this.amountOfDigitalCurrencyReceivedValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyShowNumberOfTransactions: true,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Total Digital Currency Balance',
        propertyIconId: 'attach_money',
        propertyValue: this.totalDigitalCurrencyBalanceValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyShowNumberOfTransactions: true,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Transactions Created',
        propertyIconId: 'description',
        propertyValue: this.numberOfTransactionsCreatedValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Transactions Received',
        propertyIconId: 'description',
        propertyValue: this.numberOfTransactionsReceivedValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Transactions Deleted',
        propertyIconId: 'description',
        propertyValue: this.numberOfTransactionsDeletedValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Total Active Transactions',
        propertyIconId: 'description',
        propertyValue: this.totalActiveTransactionsValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Recurring Transactions Created',
        propertyIconId: 'autorenew',
        propertyValue: this.numberOfRecurringTransactionsCreatedValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Recurring Transactions Received',
        propertyIconId: 'autorenew',
        propertyValue: this.numberOfRecurringTransactionsReceivedValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Recurring Transactions Deleted',
        propertyIconId: 'autorenew',
        propertyValue: this.numberOfRecurringTransactionsDeletedValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Total Active Recurring Transactions',
        propertyIconId: 'autorenew',
        propertyValue: this.totalActiveRecurringTransactionsValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Total Recurring Transaction Income',
        propertyIconId: 'autorenew',
        propertyValue: this.totalRecurringTransactionIncomeValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyShowNumberOfTransactions: true,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Total Recurring Transaction Expenditure',
        propertyIconId: 'autorenew',
        propertyValue: this.totalRecurringTransactionExpenditureValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyShowNumberOfTransactions: true,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Accounts Sent A Transaction To',
        propertyIconId: 'person',
        propertyValue: this.numberOfAccountsSentATransactionToValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }, {
        propertyName: 'Number of Accounts Received A Transaction From',
        propertyIconId: 'person',
        propertyValue: this.numberOfAccountsReceivedATransactionFromValue || 0,
        showAnimatedCurrencyLabel: true,
        animatedCurrencyLabelPropertyShowVerticalUpdateList: false,
        animatedCurrencyLabelPropertyMaximumNumberOfUnitPlaces: Infinity,
        animatedCurrencyLabelPropertyMaximumNumberOfDecimalPlaces: Infinity
      }]
    }

    // Data Tables
    const dataTableDataTableFile = new DataTableFile()
    dataTableDataTableFile.itemType = itemTypeFolder
    dataTableDataTableFile.itemId = 'data-tables'
    dataTableDataTableFile.itemName = 'Data Tables'
    dataTableDataTableFile.itemIconImageUrl = 'list'

    const createdTransactionDataTableDataTableFile = new DataTableFile()
    createdTransactionDataTableDataTableFile.itemType = itemTypeGraph
    createdTransactionDataTableDataTableFile.itemId = CREATED_TRANSACTION_DATA_TABLE
    createdTransactionDataTableDataTableFile.itemName = 'Sent Transactions'
    createdTransactionDataTableDataTableFile.itemIconImageUrl = 'send'

    createdTransactionDataTableDataTableFile.itemData = {
      graphType: 'data-table',
      graphData: {
        hasOpeningIcon: true,
        hasClosingActionButton: true,
        dataTableShowSelectCheckbox: true,
        propertyHtmlItemRecipientList: ['itemData.transactionPaymentAmount', 'itemData.recurrencePeriod', 'itemData.transactionStatus'],
        dataTableSearchTextFieldLabel: 'Search Transactions',
        dataTableActionButtonList: this.selectedGroupItemList.length > 0 ? this.getDataTableActionButtonList.buttonList : [],
        dataTableSelectItemEventListener: (data: any) => {
          Vue.set(this, 'selectedGroupItemList', data)
        },
        dataTableHeaderList: [{
          text: 'Transaction Order Index',
          value: 'itemName'
        }, {
          text: 'Time Created',
          value: 'dateCreated'
        }, {
          text: 'Transaction Amount',
          value: 'itemData.transactionPaymentAmount'
        }, {
          text: 'Recurrence Period',
          value: 'itemData.recurrencePeriod'
        }, {
          text: 'Status',
          value: 'itemData.transactionStatus'
        }],
        dataTableDataList: this.createdTransactionDataList
      }
    }
    createdTransactionDataTableDataTableFile.fileVariableTable = this.createdTransactionDataList.reduce((map: any, obj: any, index: number) => (map[obj.itemId] = this.createdTransactionDataList[index], map), {})

    const receivedTransactionDataTableDataTableFile = new DataTableFile()
    receivedTransactionDataTableDataTableFile.itemType = itemTypeGraph
    receivedTransactionDataTableDataTableFile.itemId = RECEIVED_TRANSACTION_DATA_TABLE
    receivedTransactionDataTableDataTableFile.itemName = 'Received Transactions'
    receivedTransactionDataTableDataTableFile.itemIconImageUrl = 'vertical_align_bottom'
    receivedTransactionDataTableDataTableFile.itemData = {
      graphType: 'data-table',
      graphData: {
        hasOpeningIcon: true,
        hasClosingActionButton: true,
        propertyHtmlItemRecipientList: ['itemData.transactionPaymentAmount', 'itemData.recurrencePeriod', 'itemData.transactionStatus'],
        dataTableSearchTextFieldLabel: 'Search Transactions',
        dataTableHeaderList: [{
          text: 'Transaction Order Index',
          value: 'itemName'
        }, {
          text: 'Time Created',
          value: 'dateCreated'
        }, {
          text: 'Transaction Amount',
          value: 'itemData.transactionPaymentAmount'
        }, {
          text: 'Recurrence Period',
          value: 'itemData.recurrencePeriod'
        }, {
          text: 'Status',
          value: 'itemData.transactionStatus'
        }],
        dataTableDataList: this.receivedTransactionDataList
      }
    }
    receivedTransactionDataTableDataTableFile.fileVariableTable = this.receivedTransactionDataList.reduce((map: any, obj: any, index: number) => (map[obj.itemId] = this.receivedTransactionDataList[index], map), {})

    dataTableDataTableFile.fileVariableTable![createdTransactionDataTableDataTableFile.itemId] = createdTransactionDataTableDataTableFile
    dataTableDataTableFile.fileVariableTable![receivedTransactionDataTableDataTableFile.itemId] = receivedTransactionDataTableDataTableFile

    // Bar Graphs
    const barGraphDataTableFile = new DataTableFile()
    barGraphDataTableFile.itemType = itemTypeFolder
    barGraphDataTableFile.itemId = 'bar-graphs'
    barGraphDataTableFile.itemName = 'Bar Graphs'
    barGraphDataTableFile.itemIconImageUrl = 'bar_chart'

    const amountOfDigitalCurrencySentGraphDataTableFile = new DataTableFile()
    amountOfDigitalCurrencySentGraphDataTableFile.itemType = itemTypeGraph
    amountOfDigitalCurrencySentGraphDataTableFile.itemId = AMOUNT_OF_DIGITAL_CURRENCY_SENT_GRAPH
    amountOfDigitalCurrencySentGraphDataTableFile.itemName = 'Amount of Digital Currency Sent'
    amountOfDigitalCurrencySentGraphDataTableFile.itemIconImageUrl = 'send'
    amountOfDigitalCurrencySentGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Amount of Digital Currency Sent',
        dateList: this.amountOfDigitalCurrencySentGraphDateList,
        dataList: this.amountOfDigitalCurrencySentGraphDataList
      }
    }

    const amountOfDigitalCurrencyReceivedGraphDataTableFile = new DataTableFile()
    amountOfDigitalCurrencyReceivedGraphDataTableFile.itemType = itemTypeGraph
    amountOfDigitalCurrencyReceivedGraphDataTableFile.itemId = AMOUNT_OF_DIGITAL_CURRENCY_RECEIVED_GRAPH
    amountOfDigitalCurrencyReceivedGraphDataTableFile.itemName = 'Amount of Digital Currency Received'
    amountOfDigitalCurrencyReceivedGraphDataTableFile.itemIconImageUrl = 'vertical_align_bottom'
    amountOfDigitalCurrencyReceivedGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Amount of Digital Currency Received',
        dateList: this.amountOfDigitalCurrencyReceivedGraphDateList,
        dataList: this.amountOfDigitalCurrencyReceivedGraphDataList
      }
    }

    const totalDigitalCurrencyBalanceGraphDataTableFile = new DataTableFile()
    totalDigitalCurrencyBalanceGraphDataTableFile.itemType = itemTypeGraph
    totalDigitalCurrencyBalanceGraphDataTableFile.itemId = TOTAL_DIGITAL_CURRENCY_BALANCE_GRAPH
    totalDigitalCurrencyBalanceGraphDataTableFile.itemName = 'Total Digital Currency Balance'
    totalDigitalCurrencyBalanceGraphDataTableFile.itemIconImageUrl = 'attach_money'
    totalDigitalCurrencyBalanceGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Total Digital Currency Balance',
        dateList: this.totalDigitalCurrencyBalanceGraphDateList,
        dataList: this.totalDigitalCurrencyBalanceGraphDataList
      }
    }

    const numberOfTransactionCreatedGraphDataTableFile = new DataTableFile()
    numberOfTransactionCreatedGraphDataTableFile.itemType = itemTypeGraph
    numberOfTransactionCreatedGraphDataTableFile.itemId = NUMBER_OF_TRANSACTIONS_CREATED_GRAPH
    numberOfTransactionCreatedGraphDataTableFile.itemName = 'Number of Transactions Created'
    numberOfTransactionCreatedGraphDataTableFile.itemIconImageUrl = 'description'
    numberOfTransactionCreatedGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Transactions Created',
        dateList: this.numberOfTransactionsCreatedGraphDateList,
        dataList: this.numberOfTransactionsCreatedGraphDataList
      }
    }

    const numberOfTransactionReceivedGraphDataTableFile = new DataTableFile()
    numberOfTransactionReceivedGraphDataTableFile.itemType = itemTypeGraph
    numberOfTransactionReceivedGraphDataTableFile.itemId = NUMBER_OF_TRANSACTIONS_RECEIVED_GRAPH
    numberOfTransactionReceivedGraphDataTableFile.itemName = 'Number of Transactions Received'
    numberOfTransactionReceivedGraphDataTableFile.itemIconImageUrl = 'description'
    numberOfTransactionReceivedGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Transactions Received',
        dateList: this.numberOfTransactionsReceivedGraphDateList,
        dataList: this.numberOfTransactionsReceivedGraphDataList
      }
    }

    const numberOfTransactionDeletedGraphDataTableFile = new DataTableFile()
    numberOfTransactionDeletedGraphDataTableFile.itemType = itemTypeGraph
    numberOfTransactionDeletedGraphDataTableFile.itemId = NUMBER_OF_TRANSACTIONS_DELETED_GRAPH
    numberOfTransactionDeletedGraphDataTableFile.itemName = 'Number of Transactions Deleted'
    numberOfTransactionDeletedGraphDataTableFile.itemIconImageUrl = 'description'
    numberOfTransactionDeletedGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Transactions Deleted',
        dateList: this.numberOfTransactionsDeletedGraphDateList,
        dataList: this.numberOfTransactionsDeletedGraphDataList
      }
    }

    const totalActiveTransactionsGraphDataTableFile = new DataTableFile()
    totalActiveTransactionsGraphDataTableFile.itemType = itemTypeGraph
    totalActiveTransactionsGraphDataTableFile.itemId = TOTAL_ACTIVE_TRANSACTIONS_GRAPH
    totalActiveTransactionsGraphDataTableFile.itemName = 'Total Active Transactions'
    totalActiveTransactionsGraphDataTableFile.itemIconImageUrl = 'description'
    totalActiveTransactionsGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Total Active Transactions',
        dateList: this.totalActiveTransactionsGraphDateList,
        dataList: this.totalActiveTransactionsGraphDataList
      }
    }

    const numberOfRecurringTransactionsCreatedGraphDataTableFile = new DataTableFile()
    numberOfRecurringTransactionsCreatedGraphDataTableFile.itemType = itemTypeGraph
    numberOfRecurringTransactionsCreatedGraphDataTableFile.itemId = NUMBER_OF_RECURRING_TRANSACTIONS_CREATED_GRAPH
    numberOfRecurringTransactionsCreatedGraphDataTableFile.itemName = 'Number of Recurring Transactions Created'
    numberOfRecurringTransactionsCreatedGraphDataTableFile.itemIconImageUrl = 'autorenew'
    numberOfRecurringTransactionsCreatedGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Recurring Transactions Created',
        dateList: this.numberOfRecurringTransactionsCreatedGraphDateList,
        dataList: this.numberOfRecurringTransactionsCreatedGraphDataList
      }
    }

    const numberOfRecurringTransactionsReceivedGraphDataTableFile = new DataTableFile()
    numberOfRecurringTransactionsReceivedGraphDataTableFile.itemType = itemTypeGraph
    numberOfRecurringTransactionsReceivedGraphDataTableFile.itemId = NUMBER_OF_RECURRING_TRANSACTIONS_RECEIVED_GRAPH
    numberOfRecurringTransactionsReceivedGraphDataTableFile.itemName = 'Number of Recurring Transactions Received'
    numberOfRecurringTransactionsReceivedGraphDataTableFile.itemIconImageUrl = 'autorenew'
    numberOfRecurringTransactionsReceivedGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Recurring Transactions Received',
        dateList: this.numberOfRecurringTransactionsReceivedGraphDateList,
        dataList: this.numberOfRecurringTransactionsReceivedGraphDataList
      }
    }

    const numberOfRecurringTransactionsDeletedGraphDataTableFile = new DataTableFile()
    numberOfRecurringTransactionsDeletedGraphDataTableFile.itemType = itemTypeGraph
    numberOfRecurringTransactionsDeletedGraphDataTableFile.itemId = NUMBER_OF_RECURRING_TRANSACTIONS_DELETED_GRAPH
    numberOfRecurringTransactionsDeletedGraphDataTableFile.itemName = 'Number of Recurring Transactions Deleted'
    numberOfRecurringTransactionsDeletedGraphDataTableFile.itemIconImageUrl = 'autorenew'
    numberOfRecurringTransactionsDeletedGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Recurring Transactions Deleted',
        dateList: this.numberOfRecurringTransactionsDeletedGraphDateList,
        dataList: this.numberOfRecurringTransactionsDeletedGraphDataList
      }
    }

    const totalActiveRecurringTransactionsGraphDataTableFile = new DataTableFile()
    totalActiveRecurringTransactionsGraphDataTableFile.itemType = itemTypeGraph
    totalActiveRecurringTransactionsGraphDataTableFile.itemId = TOTAL_ACTIVE_RECURRING_TRANSACTIONS_GRAPH
    totalActiveRecurringTransactionsGraphDataTableFile.itemName = 'Total Active Reucrring Transactions'
    totalActiveRecurringTransactionsGraphDataTableFile.itemIconImageUrl = 'autorenew'
    totalActiveRecurringTransactionsGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Total Active Reucrring Transactions',
        dateList: this.totalActiveRecurringTransactionsGraphDateList,
        dataList: this.totalActiveRecurringTransactionsGraphDataList
      }
    }

    const totalRecurringTransactionIncomeGraphDataTableFile = new DataTableFile()
    totalRecurringTransactionIncomeGraphDataTableFile.itemType = itemTypeGraph
    totalRecurringTransactionIncomeGraphDataTableFile.itemId = TOTAL_RECURRING_TRANSACTION_INCOME_GRAPH
    totalRecurringTransactionIncomeGraphDataTableFile.itemName = 'Total Recurring Transaction Income'
    totalRecurringTransactionIncomeGraphDataTableFile.itemIconImageUrl = 'autorenew'
    totalRecurringTransactionIncomeGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Total Recurring Transaction Income',
        dateList: this.totalRecurringTransactionIncomeGraphDateList,
        dataList: this.totalRecurringTransactionIncomeGraphDataList
      }
    }

    const totalRecurringTransactionExpenditureGraphDataTableFile = new DataTableFile()
    totalRecurringTransactionExpenditureGraphDataTableFile.itemType = itemTypeGraph
    totalRecurringTransactionExpenditureGraphDataTableFile.itemId = TOTAL_RECURRING_TRANSACTION_EXPENDITURE_GRAPH
    totalRecurringTransactionExpenditureGraphDataTableFile.itemName = 'Total Recurring Transaction Expenditure'
    totalRecurringTransactionExpenditureGraphDataTableFile.itemIconImageUrl = 'autorenew'
    totalRecurringTransactionExpenditureGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Total Recurring Transaction Expenditure',
        dateList: this.totalRecurringTransactionExpenditureGraphDateList,
        dataList: this.totalRecurringTransactionExpenditureGraphDataList
      }
    }

    const numberOfAccountsSentATransactionToGraphDataTableFile = new DataTableFile()
    numberOfAccountsSentATransactionToGraphDataTableFile.itemType = itemTypeGraph
    numberOfAccountsSentATransactionToGraphDataTableFile.itemId = NUMBER_OF_ACCOUNTS_SENT_A_TRANSACTION_TO_GRAPH
    numberOfAccountsSentATransactionToGraphDataTableFile.itemName = 'Number of Accounts Sent A Transaction To'
    numberOfAccountsSentATransactionToGraphDataTableFile.itemIconImageUrl = 'person'
    numberOfAccountsSentATransactionToGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Accounts Sent A Transaction To',
        dateList: this.numberOfAccountsSentATransactionToGraphDateList,
        dataList: this.numberOfAccountsSentATransactionToGraphDataList
      }
    }

    const numberOfAccountsReceivedATransactionFromGraphDataTableFile = new DataTableFile()
    numberOfAccountsReceivedATransactionFromGraphDataTableFile.itemType = itemTypeGraph
    numberOfAccountsReceivedATransactionFromGraphDataTableFile.itemId = NUMBER_OF_ACCOUNTS_RECEIVED_A_TRANSACTION_FROM_GRAPH
    numberOfAccountsReceivedATransactionFromGraphDataTableFile.itemName = 'Number of Accounts Received A Transaction From'
    numberOfAccountsReceivedATransactionFromGraphDataTableFile.itemIconImageUrl = 'person'
    numberOfAccountsReceivedATransactionFromGraphDataTableFile.itemData = {
      graphType: 'bar-graph',
      graphData: {
        xAxisLabel: 'Date',
        yAxisLabel: 'Number of Accounts Received A Transaction From',
        dateList: this.numberOfAccountsReceivedATransactionFromGraphDateList,
        dataList: this.numberOfAccountsReceivedATransactionFromGraphDataList
      }
    }

    barGraphDataTableFile.fileVariableTable![amountOfDigitalCurrencySentGraphDataTableFile.itemId] = amountOfDigitalCurrencySentGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![amountOfDigitalCurrencyReceivedGraphDataTableFile.itemId] = amountOfDigitalCurrencyReceivedGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![totalDigitalCurrencyBalanceGraphDataTableFile.itemId] = totalDigitalCurrencyBalanceGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfTransactionCreatedGraphDataTableFile.itemId] = numberOfTransactionCreatedGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfTransactionReceivedGraphDataTableFile.itemId] = numberOfTransactionReceivedGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfTransactionDeletedGraphDataTableFile.itemId] = numberOfTransactionDeletedGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![totalActiveTransactionsGraphDataTableFile.itemId] = totalActiveTransactionsGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfRecurringTransactionsCreatedGraphDataTableFile.itemId] = numberOfRecurringTransactionsCreatedGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfRecurringTransactionsReceivedGraphDataTableFile.itemId] = numberOfRecurringTransactionsReceivedGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfRecurringTransactionsDeletedGraphDataTableFile.itemId] = numberOfRecurringTransactionsDeletedGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![totalActiveRecurringTransactionsGraphDataTableFile.itemId] = totalActiveRecurringTransactionsGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![totalRecurringTransactionIncomeGraphDataTableFile.itemId] = totalRecurringTransactionIncomeGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![totalRecurringTransactionExpenditureGraphDataTableFile.itemId] = totalRecurringTransactionExpenditureGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfAccountsSentATransactionToGraphDataTableFile.itemId] = numberOfAccountsSentATransactionToGraphDataTableFile
    barGraphDataTableFile.fileVariableTable![numberOfAccountsReceivedATransactionFromGraphDataTableFile.itemId] = numberOfAccountsReceivedATransactionFromGraphDataTableFile

    this.initialFile.fileVariableTable![valuesDataTableFile.itemId] = valuesDataTableFile
    this.initialFile.fileVariableTable![dataTableDataTableFile.itemId] = dataTableDataTableFile
    this.initialFile.fileVariableTable![barGraphDataTableFile.itemId] = barGraphDataTableFile

    return this.initialFile
  }

  async onSelectedFolderDataTableItem (selectedItem: DataTableFile) {

    if (!selectedItem) {
      return
    }

    this.currentSelectedItem = selectedItem

    if (selectedItem.itemId === CREATED_TRANSACTION_DATA_TABLE) {
      console.log('created transaction')
      this.updateDigitalCurrencyAccountNotifications({
        digitalCurrencyAccountId: this.digitalCurrencyAccountId,
        serviceType: DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE,
        updateOptions: {
          serviceItemId: CREATED_TRANSACTIONS
        }
      })
    } else if (selectedItem.itemId === RECEIVED_TRANSACTION_DATA_TABLE) {
      this.updateDigitalCurrencyAccountNotifications({
        digitalCurrencyAccountId: this.digitalCurrencyAccountId,
        serviceType: DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE,
        updateOptions: {
          serviceItemId: RECEIVED_TRANSACTIONS
        }
      })
    }
  }

  async onDeleteFolderDataTableItem (itemId: any) {
    if (!itemId || !this.currentSelectedItem) {
      return
    }

    if (this.currentSelectedItem.itemId === CREATED_TRANSACTION_DATA_TABLE) {
      let indexOfItem = -1
      this.createdTransactionDataList.filter((digitalCurrencyTransaction, index) => {
        const isItem = digitalCurrencyTransaction.itemId === itemId
        if (isItem) {
          indexOfItem = index
        }
        return isItem
      })

      if (indexOfItem >= 0) {
        this.createdTransactionDataList.splice(indexOfItem, 1)
      }
    }
  }

  get getDataTableActionButtonList () {
    const dataTableActionButtonList = [{
      iconImageId: 'delete',
      text: 'Delete',
      cssClass: 'error',
      evaluateFunction: () => {
        this.showAreYouSureDialog = true
        this.areYouSureDialogIconId = 'cancel'
        this.areYouSureDialogTitle = 'Delete Transactions'
        this.areYouSureDialogMessage = `Are you sure you wish to delete ${this.selectedGroupItemList.length} ${this.selectedGroupItemList.length > 1 ? 'transactions' : 'transaction'}?`
        this.areYouSureDialogHeaderCssClass = 'error'

        this.areYouSureDialogYesOptionEvaluationFunction = async () => {
          // Delete items
          for (let i = 0; i < this.selectedGroupItemList.length; i++) {
            const digitalCurrencyTransactionId = this.selectedGroupItemList[i].itemId
            await this.deleteDigitalCurrencyTransaction(digitalCurrencyTransactionId)
          }

          if (this.currentSelectedItem.itemId === CREATED_TRANSACTION_DATA_TABLE) {
            for (let i = 0; i < this.selectedGroupItemList.length; i++) {
              const digitalCurrencyTransactionId = this.selectedGroupItemList[i].itemId
              const indexOfTransaction = this.createdTransactionDataList.map((item) => item.itemId).indexOf(digitalCurrencyTransactionId)
              if (indexOfTransaction < 0) {
                continue
              }
              this.createdTransactionDataList.splice(indexOfTransaction, 1)
            }
          }

          // Reset Are You Sure Dialog
          this.resetAreYouSureDialog()

          this.selectedGroupItemList = []
        }
      }
    }]

    let isSelectedItemListOnlyRecurringTransactions = false

    if (isSelectedItemListOnlyRecurringTransactions) {
      dataTableActionButtonList.unshift({
        iconImageId: 'cancel',
        text: 'Stop Subscription',
        cssClass: 'error',
        evaluateFunction: async () => {
          //
        }
      })
    }

    return {
      buttonList: dataTableActionButtonList,
      blankValue: ''
    }
  }

  resetAreYouSureDialog () {
    this.showAreYouSureDialog = false
    this.areYouSureDialogIconId = ''
    this.areYouSureDialogTitle = ''
    this.areYouSureDialogMessage = ''
    this.areYouSureDialogHeaderCssClass = ''
    this.areYouSureDialogYesOptionEvaluationFunction = () => false
  }

  getDigitalCurrencyTransactionStatusInformation (digitalCurrencyTransaction: DigitalCurrencyTransaction) {
    const transactionStatus = getTransactionProcessingStatusAlgorithm.function(digitalCurrencyTransaction)
    let transactionStatusIconId = ''
    let transactionStatusIconColor = ''
    let transactionStatusText = ''

    if (transactionStatus === TRANSACTION_PROCESSING_COMPLETE) {
      transactionStatusIconId = 'check_circle'
      transactionStatusIconColor = 'success'
      transactionStatusText = 'Completed'
    } else if (transactionStatus === TRANSACTION_PROCESSING_PENDING) {
      transactionStatusIconId = 'warning'
      transactionStatusIconColor = 'warning'
      transactionStatusText = 'Pending'
    } else if (transactionStatus === TRANSACTION_PROCESSING_FAILED) {
      transactionStatusIconId = 'error'
      transactionStatusIconColor = 'error'
      transactionStatusText = 'Failure'
    } else if (transactionStatus === TRANSACTION_PROCESSING_FAILED_WITH_RECURRING_TRANSACTION) {
      transactionStatusIconId = 'error'
      transactionStatusIconColor = 'error'
      transactionStatusText = 'Stopped With Error'
    } else if (transactionStatus === TRANSACTION_PROCESSING_STOPPED_WITH_RECURRING_TRANSACTION) {
      transactionStatusIconId = 'pause'
      transactionStatusIconColor = 'error'
      transactionStatusText = 'Paused'
    } else if (transactionStatus === TRANSACTION_PROCESSING_ACTIVE_WITH_RECURRING_TRANSACTION) {
      transactionStatusIconId = 'loop'
      transactionStatusIconColor = 'success'
      transactionStatusText = 'Active'
    }

    return {
      transactionStatusIconId,
      transactionStatusIconColor,
      transactionStatusText
    }
  }

  async onUpdateGraphViewDataTablePageData (pageData: any) {
    const isLastPage = pageData.pageCount !== 0 && pageData.page === pageData.pageCount

    if (!isLastPage) {
      return
    }

    if (this.currentSelectedItem.itemId === CREATED_TRANSACTION_DATA_TABLE) {
      const numberOfTransactionsToLoad = pageData.itemsPerPage - (this.createdTransactionDataList.length % pageData.itemsPerPage) + 1
      if (this.promiseToLoadNextCreatedTransactions) {
        await this.promiseToLoadNextCreatedTransactions
      }
      this.promiseToLoadNextCreatedTransactions = this.getNextPageOfCreatedTransactions(numberOfTransactionsToLoad)
      await this.promiseToLoadNextCreatedTransactions
    } else if (this.currentSelectedItem.itemId === RECEIVED_TRANSACTION_DATA_TABLE) {
      // const numberOfTransactionsToLoad = pageData.itemsPerPage - (this.receivedTransactionDataList.length % pageData.itemsPerPage) + 1
      // if (this.promiseToLoadNextReceivedTransactions) {
      //   await this.promiseToLoadNextReceivedTransactions
      // }
      // this.promiseToLoadNextReceivedTransactions = this.getNextPageOfReceivedTransactions(numberOfTransactionsToLoad)
      // await this.promiseToLoadNextReceivedTransactions
    }
  }

  async getNextPageOfCreatedTransactions (numberOfTransactionsToLoad: number) {
    if (this.isCompletedLoadingAllCreatedTransactions) {
      return
    }

    const networkStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: CREATED_TRANSACTION_DATA_TABLE,
      statisticsOptions: {
        digitalCurrencyAccountId: this.digitalCurrencyAccountId,
        getItem1Options: {
          orderByValue: true,
          // startAfter: { value: this.dateOfLatestCreatedTransactionLoaded - 2 * 60 * 60 * 1000 },
          endBefore: { value: this.dateOfLatestCreatedTransactionLoaded - 1 },
          limitToLast: numberOfTransactionsToLoad
        }
      } as GetAccountTransactionStatisticsOptions
    })

    if (!networkStatistics.dataList || networkStatistics.dataList.length === 0) {
      this.isCompletedLoadingAllCreatedTransactions = true
      return
    }

    if (networkStatistics.dataList.length < numberOfTransactionsToLoad) {
      this.isCompletedLoadingAllCreatedTransactions = true
    }

    let nextPageOfCreatedTransactionsList = await this.getDigitalCurrencyCreatedTransactionDataTableList(networkStatistics.dataList)
    this.dateOfLatestCreatedTransactionLoaded = nextPageOfCreatedTransactionsList[nextPageOfCreatedTransactionsList.length - 1].itemData.dateTransactionCreated
    nextPageOfCreatedTransactionsList = [...this.createdTransactionDataList, ...nextPageOfCreatedTransactionsList]

    Vue.set(this, 'createdTransactionDataList', nextPageOfCreatedTransactionsList)

    this.promiseToLoadNextCreatedTransactions = null
  }

  async getNextPageOfReceivedTransactions (numberOfTransactionsToLoad: number) {
    if (this.isCompletedLoadingAllReceivedTransactions) {
      return
    }

    const networkStatistics = await this.getDigitalCurrencyAccountTransactionStatistics({
      statisticsType: RECEIVED_TRANSACTION_DATA_TABLE,
      statisticsOptions: {
        digitalCurrencyAccountId: this.digitalCurrencyAccountId,
        getItem1Options: {
          orderByValue: true,
          // startAfter: { value: this.dateOfLatestReceivedTransactionLoaded - 2 * 60 * 60 * 1000 },
          endBefore: { value: this.dateOfLatestReceivedTransactionLoaded - 1 },
          limitToLast: numberOfTransactionsToLoad
        }
      } as GetAccountTransactionStatisticsOptions
    })

    if (!networkStatistics.dataList || networkStatistics.dataList.length === 0) {
      this.isCompletedLoadingAllReceivedTransactions = true
      return
    }

    if (networkStatistics.dataList.length < numberOfTransactionsToLoad) {
      this.isCompletedLoadingAllReceivedTransactions = true
    }

    let nextPageOfReceivedTransactionsList = await this.getDigitalCurrencyReceivedTransactionDataTableList(networkStatistics.dataList)
    this.dateOfLatestReceivedTransactionLoaded = nextPageOfReceivedTransactionsList[nextPageOfReceivedTransactionsList.length - 1].itemData.dateTransactionCreated
    nextPageOfReceivedTransactionsList = [...this.receivedTransactionDataList.slice(0, this.receivedTransactionDataList.length - this.numberOfSpecialReceivedTransactions), ...nextPageOfReceivedTransactionsList, ...this.receivedTransactionDataList.slice(this.receivedTransactionDataList.length - this.numberOfSpecialReceivedTransactions, this.receivedTransactionDataList.length)]

    Vue.set(this, 'receivedTransactionDataList', nextPageOfReceivedTransactionsList)

    this.promiseToLoadNextReceivedTransactions = null
  }
}

export default AccountResourceItem3TransactionStatistics


